import {bindable} from 'aurelia-framework';

export class InfoModal{
    @bindable titlem;
    @bindable content;
    @bindable showinfo;
    hide(){
        this.showinfo = false;
    }
}